var _defs, _rect, _rect2, _rect3, _g, _g2, _g3, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaleSeason(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "seasonGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF9800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1976D2"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "seasonPattern",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,20 L25,35 L10,25 L25,15 Z",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.5,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80,30 L65,50 L85,45 Z",
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.5,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 70,
    r: 5,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 0.5,
    opacity: 0.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#seasonGradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "url(#seasonPattern)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 780,
    height: 180,
    rx: 5,
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-60,-40 C-30,-30 -70,0 -40,30 C-10,0 -50,-30 -20,-20 C-30,10 -50,10 -40,30",
    fill: "#FF5722",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40,30 L-35,40",
    stroke: "#795548",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,-50 C10,-40 -30,-10 0,20 C30,-10 -10,-40 20,-30 C10,0 -10,0 0,20",
    fill: "#FF9800",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,20 L5,30",
    stroke: "#795548",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,-30 C50,-20 10,10 40,40 C70,10 30,-20 60,-10 C50,20 30,20 40,40",
    fill: "#F44336",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,40 L45,50",
    stroke: "#795548",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 100)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-60, -40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,30 M0,0 L26,15 M0,0 L-26,15 M0,0 L0,-30 M0,0 L26,-15 M0,0 L-26,-15",
    stroke: "#E3F2FD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10 L9,5 L-9,5 Z M0,-10 L9,-5 L-9,-5 Z M8.7,5 L13,14 L4,9 Z M-8.7,5 L-13,14 L-4,9 Z M8.7,-5 L13,-14 L4,-9 Z M-8.7,-5 L-13,-14 L-4,-9 Z",
    fill: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,20 M0,0 L17,10 M0,0 L-17,10 M0,0 L0,-20 M0,0 L17,-10 M0,0 L-17,-10",
    stroke: "#E3F2FD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7 L6,3.5 L-6,3.5 Z M0,-7 L6,-3.5 L-6,-3.5 Z M5.8,3.3 L8.7,9.3 L2.7,6 Z M-5.8,3.3 L-8.7,9.3 L-2.7,6 Z M5.8,-3.3 L8.7,-9.3 L2.7,-6 Z M-5.8,-3.3 L-8.7,-9.3 L-2.7,-6 Z",
    fill: "#E3F2FD"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, -30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,25 M0,0 L22,12.5 M0,0 L-22,12.5 M0,0 L0,-25 M0,0 L22,-12.5 M0,0 L-22,-12.5",
    stroke: "#E3F2FD",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L7,4 L-7,4 Z M0,-8 L7,-4 L-7,-4 Z M6.6,3.8 L9.9,10.6 L3.1,6.8 Z M-6.6,3.8 L-9.9,10.6 L-3.1,6.8 Z M6.6,-3.8 L9.9,-10.6 L3.1,-6.8 Z M-6.6,-3.8 L-9.9,-10.6 L-3.1,-6.8 Z",
    fill: "#E3F2FD"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M200,30 C215,25 195,45 210,60 C225,45 205,25 220,30 C215,45 205,45 210,60",
    fill: "#FF9800",
    opacity: 0.5,
    transform: "rotate(15, 210, 45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,50 C315,45 295,65 310,80 C325,65 305,45 320,50 C315,65 305,65 310,80",
    fill: "#F44336",
    opacity: 0.4,
    transform: "rotate(-20, 310, 65)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(500, 40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,15 M0,0 L13,7.5 M0,0 L-13,7.5 M0,0 L0,-15 M0,0 L13,-7.5 M0,0 L-13,-7.5",
    stroke: "#E3F2FD",
    strokeWidth: 1.5,
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,10 M0,0 L8.7,5 M0,0 L-8.7,5 M0,0 L0,-10 M0,0 L8.7,-5 M0,0 L-8.7,-5",
    stroke: "#E3F2FD",
    strokeWidth: 1.5,
    opacity: 0.4
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 75,
    fontFamily: "Arial, sans-serif",
    fontSize: 35,
    fontWeight: "bold",
    fill: "#FFF",
    textAnchor: "middle"
  }, "SEASONAL SALE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 115,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#FFF",
    textAnchor: "middle"
  }, "25% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 145,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#FFF",
    textAnchor: "middle"
  }, "Limited time seasonal discount")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleSeason);
export default __webpack_public_path__ + "static/media/sale_season.d29f1c33947840198612c43149fba364.svg";
export { ForwardRef as ReactComponent };